import React, { useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { isEmpty, isNull, isUndefined } from "lodash";
import Accordion from "react-bootstrap/Accordion";
import * as CMSActions from "app/@Base/store/actions";
import * as Actions from "app/@Base/store/actions";
import Breadcrumbs from "@components/Breadcrumbs/Breadcrumbs";
import Meta from "@components/Meta/Meta";
import SearchFormBienes from "./SearchFormBienes";
import BasicBanner from "@components/BasicBanner/BasicBanner";
import BienPreview from "./BienPreview";
import BienDetalle from "./BienDetalle";
import { animations } from "react-animation";
import useMediaQuery from "app/hooks/useMediaQuery";
import placeholder from "assets/img/placeholder.png";
import Pagination from "@components/Pagination/Pagination";

import "bootstrap/dist/css/bootstrap.css";

const root = process.env.REACT_APP_CMS_STATIC;
const PageSize = 10;

function Bienes(props) {
  const dispatch = useDispatch();

  const is4K = useMediaQuery("(min-width: 3840px)");
  const isDesktop = useMediaQuery("(min-width: 992px)");
  const isIpadPortrait = useMediaQuery("(max-width: 992px)");
  const isIphoneLandscape = useMediaQuery("(max-width: 576px)");

  const [banner, setBanner] = useState({});
  const [listaBienes, setListaBienes] = useState([]);
  const [curBien, setCurBien] = useState(0);
  const [urlButtonVerDetalle, setUrlButtonVerDetalle] = useState("");
  const [showDetalleBien, setShowDetalleBien] = useState(false);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);

  const filteredBienes = useMemo(() => {
    const firstPageIndex = (currentPage - 1) * PageSize;
    const lastPageIndex = firstPageIndex + PageSize;
    return listaBienes?.slice(firstPageIndex, lastPageIndex);
  }, [currentPage, listaBienes]);

  const { rutas } = useSelector(({ Base }) => Base.ContenidoCMS);

  const { loggedUser } = useSelector(({ Base }) => Base?.User);
  const { provincias } = useSelector(({ Base }) => Base.Catalogos);
  const { cantones } = useSelector(({ Base }) => Base.Catalogos);
  const { distritos } = useSelector(({ Base }) => Base.Catalogos);
  const { tiposBien } = useSelector(({ Base }) => Base.Catalogos);
  const { bienes } = useSelector(({ Base }) => Base.Catalogos);

  const { bienesBanner } = useSelector(
    ({ AhorroYCredito }) => AhorroYCredito.AhorroYCredito
  );

  const defRoute = rutas?.filter((route) => route?.name === "Bienes");

  useEffect(() => {
    const { token } = loggedUser;
    buildParams("");
    if (token) {
      isEmpty(provincias) && dispatch(CMSActions.getProvincias(token));
      isEmpty(cantones) && dispatch(CMSActions.getCantones(token));
      isEmpty(distritos) && dispatch(CMSActions.getDistritos(token));
      isEmpty(tiposBien) && dispatch(CMSActions.getTiposBien(token));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loggedUser]);

  useEffect(() => {
    if (!isEmpty(bienesBanner)) {
      let backgroundImage;
      let mainImage = {
        img: root + bienesBanner?.bannerdeBienes[0]?.heroImage.urls[0],
        alt: "Bienes",
      };
      let title = bienesBanner?.bannerdeBienes[0]?.copyText;

      //let buttonImage = "";

      if (isIphoneLandscape) {
        backgroundImage =
          root + bienesBanner?.bannerdeBienes[0]?.imagendefondoMovil.urls[0];
      } else if (isIpadPortrait) {
        backgroundImage =
          root +
          bienesBanner?.bannerdeBienes[0]?.imagendeFondoIpadPortrait.urls[0];
      } else if (isDesktop) {
        backgroundImage =
          root + bienesBanner.bannerdeBienes[0]?.imagendefondo.urls[0];
      }

      setBanner({
        backgroundImage: {
          img: backgroundImage,
          alt: "VENTA DE BIENES",
        },
        mainImage: mainImage,
        title: title,
      });
    }
  }, [bienesBanner, isIphoneLandscape, isIpadPortrait, isDesktop]);

  useEffect(() => {
    if (!isEmpty(bienes)) {
      setListaBienes(bienes);
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bienes]);

  useEffect(() => {
    if (bienesBanner) {
      setUrlButtonVerDetalle(
        bienesBanner?.aCBienesBotonVerDetalle &&
          root + bienesBanner?.aCBienesBotonVerDetalle[0]?.imagen?.urls[0]
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bienesBanner]);

  useEffect(() => {
    curBien > 0 ? setShowDetalleBien(true) : setShowDetalleBien(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [curBien]);

  const buildParams = (selection) => {
    if (loggedUser) {
      const token = loggedUser.token;
      setLoading(true);
      setListaBienes([]);
      !isUndefined(selection) &&
        !isNull(selection) &&
        dispatch(Actions.getBienesSearch(selection, token)).then((resp) => {
          isEmpty(resp) && setLoading(false);
        });
    }
  };

  const showBienDetalle = () => {
    const info = listaBienes.filter((bien) => bien.Id === curBien);
    const btnSolicitarInfo =
      bienesBanner && !isEmpty(bienesBanner?.aCBienesBotonSolicitarInformacion)
        ? bienesBanner?.aCBienesBotonSolicitarInformacion[0]
        : {};
    const btnCotizar =
      bienesBanner && !isEmpty(bienesBanner?.aCBienesBotonCotizar)
        ? bienesBanner?.aCBienesBotonCotizar[0]
        : {};
    return (
      <BienDetalle
        bienInfo={!isEmpty(info) ? info[0] : {}}
        setCurBien={setCurBien}
        btnSolicitarInfo={btnSolicitarInfo}
        btnCotizar={btnCotizar}
      />
    );
  };

  return (
    <div
      style={
        is4K
          ? {
              width: "100%",
              paddingLeft: "1010px",
              paddingRight: "1010px",
              animation: animations.fadeIn,
            }
          : { animation: animations.fadeIn }
      }
    >
      <Meta
        title={defRoute[0]?.title}
        description={defRoute[0]?.description}
        canonicalUrl={defRoute[0]?.url}
      />
      <div style={{ zIndex: 1 }}>
        <BasicBanner
          backgroundImage={banner?.backgroundImage}
          mainImage={banner?.mainImage}
          title={banner?.title}
        />
      </div>
      <Breadcrumbs items={[]} active={defRoute[0]?.name} />
      <div style={{ zIndex: 100 }}>
        <Accordion defaultActiveKey="0">
          <Accordion.Item eventKey="0">
            <Accordion.Header>
              <div className="bienes-search-text">Buscar Bienes Por:</div>
            </Accordion.Header>
            <Accordion.Body>
              <SearchFormBienes
                buildParams={buildParams}
                loading={loading}
                setCurBien={setCurBien}
              />
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </div>
      {showDetalleBien ? (
        showBienDetalle()
      ) : !isEmpty(listaBienes) ? (
        <>
          <div
            id="resultadosBusquedaContainer"
            className="resultados-busqueda-contenedor"
            style={{ animation: animations.fadeIn }}
          >
            <div className="text-secondary results-search-bienes ps-5 pb-3 text-start">
              Resultados de Bienes
            </div>

            <div className="bienes-result-container">
              {filteredBienes?.map((bien, index) => (
                <BienPreview
                  key={index}
                  idBien={bien?.Id}
                  imagenUrl={
                    bien?.Imagenes.length > 0
                      ? bien?.ImagenPrincipal
                      : placeholder
                  }
                  imagenBotonVerDetalle={urlButtonVerDetalle}
                  tipoBien={bien?.TipoBien}
                  expediente={bien?.NumeroExpediente}
                  precio={bien?.Precio?.toString()}
                  descripcion={bien?.Descripcion}
                  setCurBien={setCurBien}
                />
              ))}
            </div>
          </div>
          <Pagination
            className="pagination-bar"
            currentPage={currentPage}
            totalCount={listaBienes.length}
            pageSize={PageSize}
            onPageChange={(page) => setCurrentPage(page)}
          />
        </>
      ) : (
        <h4>No se encontraron resultados.</h4>
      )}
    </div>
  );
}

export default Bienes;
